
import { Component, Vue } from 'vue-property-decorator'
import LsEditor from '@/components/editor.vue'
import {
  apiPolicyAgreement,
  apiPolicyAgreementEdit,
  PolicyAgreement
} from '@/api/setting'

interface ProtocolItem {
    title: string
    name: keyof PolicyAgreement
    content: keyof PolicyAgreement
}

@Component({ components: { LsEditor } })
export default class PlatformProtocol extends Vue {
    form: PolicyAgreement = {
      service_agreement_name: '',
      service_agreement_content: '',
      privacy_policy_name: '',
      privacy_policy_content: '',
      user_delete_name: '',
      user_delete_content: ''
    }

    protocols: ProtocolItem[] = [
      { title: '服务协议', name: 'service_agreement_name', content: 'service_agreement_content' },
      { title: '隐私政策', name: 'privacy_policy_name', content: 'privacy_policy_content' },
      { title: '注销协议', name: 'user_delete_name', content: 'user_delete_content' }
    ]

    created () {
      this.load()
    }

    load () {
      apiPolicyAgreement()
        .then(data => Object.assign(this.form, data))
        .catch(() => this.$message.error('数据加载失败，请刷新重载'))
    }

    submit () {
      const loading = this.$loading({ text: '保存中' })
      apiPolicyAgreementEdit(this.form)
        .then(() => this.$message.success('保存成功'))
        .catch(() => this.$message.error('保存失败'))
        .finally(() => loading.close())
    }
}
